import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Table,Input, message } from 'antd';
import { Link } from 'react-router-dom';
import ErrorWrapper from '../../lib/error_wrapper';
import { showErrorInNotification, NetworkDelaySearch, overrideHeaderTitle, overrideHeaderBack, formatMoney } from '../../lib/util';
import { BasicHeader } from '../../components/basic_header';
import { StarBorder } from '@material-ui/icons';
import {TransparentButton} from '../../components/basic_items';
import { recon_quick_menu } from '../../util/ui_util';
const queryString = require('query-string');

const recon_cols = ({ onActionPressed, onToggleFavourite }) => [
  {
    title: <StarBorder titleAccess='Favourite' className='star-inactive hand-cursor' />, dataIndex: 'favourite', key: 'favourite', render: (favourite, record) => {
      return <StarBorder
        className={favourite ? 'star-active hand-cursor' : 'star-inactive hand-cursor'}
        titleAccess="Toggle Favourite"
        onClick={() => {
          typeof onToggleFavourite === 'function' && onToggleFavourite(record.id, favourite)
        }}
      />
    }
  },
  {
    title: "NAME",
    dataIndex: "name",
    key: 'name'
  },
  {
    title: "OUR DATATYPE",
    dataIndex: "our_data_type_name",
    key: 'our_data_type_name',
  },

  {
    title: "THEIR DATATYPE",
    dataIndex: "their_data_type_name",
    key: 'their_data_type_name',
  },
  {
    title: "ACTION",
    dataIndex: "id",
    key: 'id',
    render: (id) => {
      return <span>
        <Link to={`/recon/reconcilers/${id}`} style={{
          // color:'inherit'
        }}>
        <TransparentButton
          className='cta-normal'
          label="Overview"
          // icon={<StorageOutlined />}
        />
        {/* <Button style={{ padding: 0 }} type='link'>Overview</Button> */}
      </Link>
      </span>
    }
  },

]

class ReconcilerListView extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter_query: {}
    };
    this.list_reconcilers = RESTExecutor.list().config({
      label: 'list_reconcilers',
    }).connect(props.domains.reconciliation);

    this.mark_favourite = RESTExecutor.post().config({
      label: 'reconcilers_mark_fav'
    }).callbacks((success) => {
      message.success("Marked Favourite");
      this.list_reconcilers.execute();
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);


    this.unmark_favourite = RESTExecutor.post().config({
      label: 'reconcilers_unmark_fav'
    }).callbacks((success) => {
      message.success("Removed Favourite");
      this.list_reconcilers.execute();
    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.reconciliation);

    this.delay_search = new NetworkDelaySearch();


  };

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }

  render() {
    let list_reconcilers_resp = this.list_reconcilers.response();
    let list_reconcilers_data = list_reconcilers_resp.result || {};
    let reconcilers_list = list_reconcilers_data.rows || [];

    let rowsMeta = list_reconcilers_resp.meta || {};
    const { filter_query } = this.state;

    return (
      <ErrorWrapper
        error={list_reconcilers_resp}
        onReload={() => {
          this.list_reconcilers.execute()
        }}
      >
        <BasicHeader
          no_back
          title="Reconcilers"
          menu_items={recon_quick_menu}
        />
        <div className='filter-card'>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12
          }}>
            <Input.Search
              placeholder="Search For"
              style={{
              }} autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, per_page: 100, page: 1 })
                      })
                    })
                  }
                })
              }} />
          </div>
        </div>
        <div className='default-card' style={{
          // padding: 8
        }}>
          <Table
            scroll={{ x: true }}
            dataSource={reconcilers_list}
            className='main-table noHover'
            loading={list_reconcilers_resp.fetching}
            columns={recon_cols({
              onToggleFavourite: (id, favourite) => {
                if (favourite) {
                  this.unmark_favourite.forId(id).execute();
                } else {
                  this.mark_favourite.forId(id).execute()
                }
              }
            })}
            size='small'
            rowKey={(record) => record.id}
            pagination={{
              // simple: true,
              onChange: (current, size) => {

                this.props.history.push({
                  // pathname:"users",
                  search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                })
                // this.list_reconcilers.config({
                //     params: {
                //         per_page: size,
                //         page: current,
                //         ...filter_query
                //     }
                // }).execute();
              },
              defaultCurrent: 1,
              current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
              // defaultPageSize: 20,
              pageSize: (rowsMeta && rowsMeta.requested_count),

              total: (rowsMeta && rowsMeta.total_count),
              showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
            }}
          />
        </div>
      </ErrorWrapper>
    );
  }
  componentDidMount() {

    overrideHeaderTitle("Reconciler List");
    overrideHeaderBack(null);
    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query
      }
    }, () => {
      this.list_reconcilers.config({
        params: {
          ...this.state.filter_query
        }
      }).execute()
    })
  }

  componentWillReceiveProps(nextProps) {

    let new_filter_query = {};
    if ((this.props.location.search !== nextProps.location.search)) {
      const parsed = queryString.parse(nextProps.location.search);
      new_filter_query = parsed;
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...new_filter_query
        }
      }, () => {
        this.list_reconcilers.config({
          params: {
            ...this.state.filter_query
          }
        }).execute()
      })
    } else {
      //   this.list_logs.execute()
    }


  }
}

export default withDomains(ReconcilerListView, "reconciliation");
